if (!window.Eurus.loadedScript.has('payment-button.js')) {
  window.Eurus.loadedScript.add('payment-button.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.store('xShopifyPaymentBtn', {
        load(e) {
          const form = e ? e.closest('form') : null;
          const telefonoPrx = sessionStorage.getItem('telefono_prx') || (new URLSearchParams(window.location.search).get('prx'));
          if (telefonoPrx && form) {
            let propInput = form.querySelector('input[name="properties[codigo_promocional]"]');
            if (!propInput) {
              propInput = document.createElement('input');
              propInput.type = 'hidden';
              propInput.name = 'properties[codigo_promocional]';
              form.appendChild(propInput);
            }
            propInput.value = telefonoPrx;
            propInput.setAttribute('value', telefonoPrx);
          }
          if (Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }
        },
      });
    });
  });
}